import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import AuthScreen from "@/pages/AuthScreen";
import Home from "@/pages/Home";
import Pratiche from "@/pages/Pratiche";
import Viaggi from "@/pages/Viaggi";
import Community from "@/pages/Community";
import ChiSiamo from "@/pages/ChiSiamo";
import Ruota from "@/pages/Ruota";

function Gate() {
  const { user } = useAuth();

  if (user === null) {
    // Initial session check — minimal calm splash
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-[#f9f5ef]" data-testid="auth-loading">
        <div className="font-serif-display italic text-[#7a6f65] text-lg">Un momento…</div>
      </div>
    );
  }

  if (!user) return <AuthScreen />;

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pratiche" element={<Pratiche />} />
        <Route path="/viaggi" element={<Viaggi />} />
        <Route path="/ruota" element={<Ruota />} />
        <Route path="/community" element={<Community />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Gate />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#f9f5ef",
              color: "#2e2820",
              border: "1px solid #ede7df",
              fontFamily: "Jost, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
